// extracted by mini-css-extract-plugin
module.exports = {"nav":"MobileNav_nav__e_UGn","open":"MobileNav_open__UpHGh","list":"MobileNav_list__9sHEn"};